import { formatAmount } from '@/services/utils'
import { Button, Typography } from '@mui/material'
import { ICourse } from 'interfaces/ICourse'
import { ISchool } from 'interfaces/school.interface'
import React from 'react'
import DialogComponent from '../../DialogComponent/DialogComponent'

export const WhitelabelCoursePaymentButton = (props: {
  courseDetails: ICourse
  school: ISchool
}) => {
  const [openDialog, setOpenDialog] = React.useState(false)

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpenDialog}>
        Pay {`${props.school?.currency_code}`}{' '}
        {formatAmount(props.courseDetails?.price)}
      </Button>
      <DialogComponent
        title="Share"
        open={openDialog}
        fullScreen={false}
        contentPadding={'0px'}
        dialogStyle={{ borderRadius: '15px !important' }}
        content={
          <div style={{ padding: '20px' }}>
            <Typography align="center" variant="body2">
              Pay {`${props.school?.currency_symbol}`}{' '}
              {formatAmount(props.courseDetails?.price)} into
            </Typography>

            <Typography align="center" variant="h6">
              {props.school?.school_bank_account_no}
            </Typography>
            <Typography align="center" variant="body1">
              {props.school?.school_bank?.name}
            </Typography>
          </div>
        }
        onRequestClose={handleCloseDialog}
        hideTitleBar
      />
    </>
  )
}
